//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate, useParams } from 'react-router-dom'

const FilterByTeam = (props) => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [leagueName, setLeagueName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [error, setError] = useState()

	const leagueId = useParams().leagueId || props.leagueId
	const divisionName = useParams().divisionName

	console.log('FilterByTeam divisionName: ' + divisionName)
	console.log('FilterByTeam props: ' + JSON.stringify(props))

	let selectedTeam
	//
	//
	//
	//Make backend call to getTeamsInLeagueByLeagueId
	/* useEffect(() => {
		const getTeamsInLeague = async () => {
			setIsLoading(true)
			console.log('reaching out to getTeamsInLeagueByLeagueId')
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueId}/teams`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.listOfTeams)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		getTeamsInLeague()
	}, [setLoadedTeams]) */
	useEffect(() => {
		// Don't make the API call until we have a valid leagueId
		if (!leagueId || leagueId === 'undefined') {
			setLoadedTeams(undefined)
			setIsLoading(false)
			return
		}

		let cancelled = false

		const getTeamsInLeague = async () => {
			setIsLoading(true)
			setError(undefined)

			console.log('FilterByTeam: fetching teams for leagueId:', leagueId)

			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueId}/teams`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				if (!cancelled) {
					setLoadedTeams(responseData.listOfTeams)
					setLeagueName(responseData.leagueName)
					setSession(responseData.session)
					setYear(responseData.year)
				}
			} catch (err) {
				if (!cancelled) {
					console.error('FilterByTeam error:', err.message)
					setError(err.message)
					setLoadedTeams(undefined)
				}
			} finally {
				if (!cancelled) {
					setIsLoading(false)
				}
			}
		}

		getTeamsInLeague()

		return () => {
			cancelled = true
		}
	}, [leagueId])
	//
	//
	//
	//
	//
	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			//const teamDisplay = team
			teamArray.push(team)
		})
	}

	//console.log('teamArray: ' + JSON.stringify(teamArray))

	let navigate = useNavigate()

	//For handling a search by TEAM request
	const handleChange2 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		console.log('selectedValue: ' + selectedValue)
		selectedTeam = loadedTeams[selectedValue]
		console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		const teamName = selectedTeam.teamName
		//
		//
		//
		//This goes to TeamSchedule.js.  If it has a divisionName, it takes that with it.
		if (divisionName) {
			console.log(
				'FilterByTeam: hey it looks like were in a division here: ' +
					divisionName,
			)
			navigate(
				`/league/schedule/${leagueName}/${divisionName}/${session}/${year}/${teamName}`,
			)
		} else {
			navigate(`/league/schedule/${leagueName}/${session}/${year}/${teamName}`)
		}
		//
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				{/* <div className='row'>
					<div className='LTVinstructions'>Filter by Team: </div>
				</div> */}
				{!isLoading && loadedTeams && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									onChange={handleChange2}
								>
									<option defaultValue>Filter by Team:</option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{team.teamName}
										</option>
									))}
								</select>
							</form>
						</div>
						<p className='schedule-search__game-summary-note'>
							Click on the final score of a game to see a Game Summary
						</p>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default FilterByTeam
